import { ActionsMenu } from "./action-menu";
import { actionMenuStyles as styles } from "./action-menu.styles";
import { actionsMenuTemplate as template } from "./action-menu.template";
/* eslint-disable sort-keys */
export const widgetActionMenu = ActionsMenu.compose({
    baseName: "widget-action-menu",
    template,
    styles,
});
